import { useState } from 'react'
import { CardCollection } from './CardCollection.js'
import { SalsaEventCardImage } from './SalsaEventCardImage.js'
import ReactHtmlParser from 'react-html-parser';

import {
	equals,
	pipe,
	add,
	always,
	cond,
	T,
	defaultTo,
	propOr,
	head,
	path,
	flatten,
	hasPath,
	pathOr
} from 'ramda'
import {
	getDate,
	isSameDay,
	isToday,
	format,
} from 'date-fns'

const getFirstCategoryName = pipe(
	propOr([], 'categories'),
	head,
	defaultTo({}),
	propOr('', 'name')
)

const locationByEventType = cond([
	[equals('Webinars'), always('Virtual')],
	[T, always('')]
])

const hasFeaturedImage = hasPath(['_embedded', 'wp:featuredmedia'])

const toCards = (events = []) => {
	return events && events.length > 0
		? events.map((event = {}) => {
			const eventStartDate = event.meta.eventStartDate ? new Date(event.meta.eventStartDate) : new Date()
			return {
				title: event.title.raw || event.title.rendered,
				id: event.id,
				href: event.link,
				image: hasFeaturedImage(event) ? {
					src: pipe(
						pathOr([], ['_embedded', 'wp:featuredmedia']),
						head,
						propOr('', 'link')
					)(event),
					alt: pipe(
						pathOr([], ['_embedded', 'wp:featuredmedia']),
						head,
						defaultTo({}),
						propOr('', 'alt_text')
					)(event)
				} : SalsaEventCardImage(flatten(event._embedded['wp:term']).find(i => i.taxonomy === 'event_types')?.slug),
				body: event?.excerpt?.raw || event?.excerpt?.rendered,
				eventDetails: {
					category: flatten(event._embedded['wp:term']).find(i => i.taxonomy === 'event_types')?.name || '',
					date: format(eventStartDate, 'MMMM d, p'),
					location: event?.meta?.eventLocation || ''
				}
			}
		})
		: []
}

export function EventsCollectionGrid(props = {}) {
	const {
		events = [],
		columns,
		rows,
		loadMoreEnabled
	} = props

	const [page, setPage] = useState(1)


	return (
		<>
			<div className="grid gap-4">
				<CardCollection cards={toCards(events)} columns={columns} rows={rows} page={page} />
			</div>
			{
				loadMoreEnabled && events.length > columns * rows * page
					? (
						<div className="text-center">
							<button
								onClick={() => {
									setPage(add(1))
								}}
								className="px-4 py-2 text-base font-semibold text-white rounded cursor-pointer bg-blue hover:bg-blue-darker">Load More</button>
						</div>
					)
					: null
			}
		</>
	)
}
